import { css } from '@mui/styled-engine'
import { HAVDesignTokensInterface } from '../interfaces'
import { havDefault01Text, havDefault02Text } from './Texts'

const havSimpleTable = (HAVDesignTokens: HAVDesignTokensInterface) => css`
  .dividers {
    border: none;
  }

  thead th,
  tbody td {
    border: ${HAVDesignTokens.shape.border.outline.none};
  }

  .MuiTableCell-head {
    ${havDefault02Text(HAVDesignTokens)}
    background-color: ${HAVDesignTokens.palette.neutral.white};
  }

  tbody {
    tr {
      background-color: ${HAVDesignTokens.palette.neutral.white};

      :nth-of-type(odd) {
        background-color: ${HAVDesignTokens.palette.hover.light};
      }

      .MuiTableCell-body {
        ${havDefault01Text(HAVDesignTokens)}
      }

      th,
      td {
        padding: ${HAVDesignTokens.spacing.stack.medium}
          ${HAVDesignTokens.spacing.stack.x.small};
      }
    }
  }
`

const havComplexTable = (HAVDesignTokens: HAVDesignTokensInterface) => css`
  ${havSimpleTable(HAVDesignTokens)}

  .MuiSvgIcon-root {
    fill: ${HAVDesignTokens.palette.neutral.light};
    font-size: ${HAVDesignTokens.icon.size.x.medium};
  }
`

export { havSimpleTable, havComplexTable }
